import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Link, useIntl } from 'gatsby-plugin-intl';
import LanguageSwitch from '../LanguageSwitch/LanguageSwitch';

import styles from './Supplier.module.scss';
import get from 'lodash/get';

function SupplierMenu() {
  const { locale } = useIntl();
  const data = useStaticQuery(graphql`{
    en: allContentfulSupplierPage(filter: {node_locale: {eq: "en-US"}}, sort: {fields: createdAt}) {
      edges {
        node {
          id
          node_locale
          slug
          title
        }
      }
    }
    de: allContentfulSupplierPage(filter: {node_locale: {eq: "de-AT"}}, sort: {fields: createdAt}) {
      edges {
        node {
          id
          node_locale
          slug
          title
        }
      }
    }
  }`);
  const menu = get(data, `${locale}.edges`);

  return (
    <div className={styles.menu}>
      <ul>
        {menu?.map(({node}: any, index: number) => (
          <li key={index}>
            <Link to={`/supplier/${node.slug}/`}>{node.title}</Link>
          </li>
        ))}
      </ul>
      <div>
        <LanguageSwitch baseURL="/supplier/"/>
      </div>
    </div>
  );
}

export default SupplierMenu;
